@if (favoritesService.favorites.length > 0) {
  <button
    matButton
    class="favorites-button"
    [disabled]="favoritesService.isWriting()"
    [matMenuTriggerFor]="favoritesMenu"
  >
    {{ 'FAVORITES' | transloco }}
    <mat-icon class="icon-dropdown">arrow_drop_down</mat-icon>
  </button>
}

<mat-menu #favoritesMenu="matMenu">
  @for (favorite of favoritesService.favorites; track favorite.id) {
    <button
      mat-menu-item
      class="favorite-item"
      [disabled]="favoritesService.isWriting()"
      [class.favorite-item--selected]="favorite.id === favoritesService.currentFavorite?.id"
      [class.favorite-item--unavailable]="!favoritesService.isApplicable(favorite)"
      [matTooltip]="tooltipKeyFor(favorite) | transloco"
      (click)="favoritesService.applyFavorite(favorite)"
    >
      <span class="label">{{ favorite.label }}</span>
      <button
        class="edit-favorite"
        matIconButton
        [matTooltip]="'EDIT_FAVORITE' | transloco"
        (click)="favoritesService.editFavorite(favorite, $event)"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        class="delete-favorite"
        matIconButton
        [matTooltip]="'DELETE_FAVORITE' | transloco"
        (click)="favoritesService.deleteFavorite(favorite, $event)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </button>
  }
</mat-menu>
